import React from 'react';

import { FollowUpEnum } from '../model';
import { Column } from 'components/Layout/Grid';
import FollowUpSlider from '..';

const FollowUpDelivered: React.FC = () => (
  <Column className="w-100 max-w-lg-100 flex-1 px-0">
    <FollowUpSlider showTypeDateFilter typeFollowUp={FollowUpEnum.DELIVERED} />
  </Column>
);

export default FollowUpDelivered;
